import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthShell, Heading, Field, SubmitButton, ErrorNote, DoneBadge } from "@/components/AuthUI";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell homeTestId="forgot-home-link" aside={false}>
      {sent ? (
        <div data-testid="forgot-sent" className="flex flex-col gap-4">
          <DoneBadge />
          <Heading
            title="Check your inbox"
            sub={`If an account exists for ${email}, we have sent a link to reset your password. It expires in 1 hour.`}
          />
          <Link to="/login" data-testid="back-to-login-link" className="text-[15px] font-semibold underline">
            Back to sign in
          </Link>
        </div>
      ) : (
        <>
          <Heading title="Forgot password?" sub="Enter your email and we will send you a reset link." />
          <form onSubmit={submit} className="flex flex-col gap-6">
            <Field
              label="Email"
              id="forgot-email"
              testid="forgot-email-input"
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={setEmail}
              required
            />
            {error && <ErrorNote testid="forgot-error">{error}</ErrorNote>}
            <SubmitButton testid="forgot-submit-button" loading={loading}>
              Send reset link
            </SubmitButton>
          </form>
          <Link to="/login" data-testid="back-to-login-link" className="text-[15px] text-soft underline self-start">
            Back to sign in
          </Link>
        </>
      )}
    </AuthShell>
  );
};
